/**
 * Sentry's Next.js client normalisation (runs before `beforeSend`) replaces any
 * frame origin with `app://`, so our bundles read `app:///_next/static/…`. We
 * serve nothing under `/executors/`; a stack made only of those frames is a
 * browser extension's script and never touched our code.
 */
const EXTENSION_EXECUTORS_PREFIX = 'app:///executors/';

export function isExtensionExecutorsStack(
  frames: readonly { filename?: string }[] | undefined
): boolean {
  if (!frames || frames.length === 0) return false;
  return frames.every((f) => f.filename?.startsWith(EXTENSION_EXECUTORS_PREFIX) === true);
}
